import * as fromDatatype from '../datatype-library';

export interface bl_alg_cc_task_campaign_link_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  task_hdr_guid: fromDatatype.GuidDataFieldInterface;
  campaign_hdr_guid: fromDatatype.GuidDataFieldInterface;
  campaign_execution_hdr_guid: fromDatatype.VarcharDatatypeClass;
  channel_type: fromDatatype.VarcharDatatypeInterface;
  endpoint_id: fromDatatype.VarcharDatatypeInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  applet_guid: fromDatatype.VarcharDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.GuidDataFieldInterface;
  vrsn: fromDatatype.VarcharDatatypeInterface;
}

export class bl_alg_cc_task_campaign_link_RowClass
  implements bl_alg_cc_task_campaign_link_RowInterface
{
  guid: fromDatatype.GuidDataFieldInterface;
  task_hdr_guid: fromDatatype.GuidDataFieldInterface;
  campaign_hdr_guid: fromDatatype.GuidDataFieldInterface;
  campaign_execution_hdr_guid: fromDatatype.VarcharDatatypeClass;
  channel_type: fromDatatype.VarcharDatatypeInterface;
  endpoint_id: fromDatatype.VarcharDatatypeInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  applet_guid: fromDatatype.VarcharDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.GuidDataFieldInterface;
  vrsn: fromDatatype.VarcharDatatypeInterface;
}
